import { lazy, Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import { RouteErrorComponent } from '@/features/app-shell/route-error-component'
import { TenantSettingsSelect } from '@/features/tenant/components/tenant-settings-select'

import { ROLES } from '@/shared/auth/constants'
import { roleAuthGuard } from '@/shared/auth/utils/router'

import { ErrorBoundary } from '@/components/common/error-boundary'
import {
	SettingsCard,
	SettingsCardTitle,
} from '@/components/common/settings-card'
import { Skeleton } from '@/components/ui/skeleton'

const CustomNotificationsSettings = lazy(
	() => import('@/features/notifications/components/recipients/settings'),
)

export const Route = createFileRoute(
	'/_dashboard/settings/tenant-settings/notification-recipients',
)({
	beforeLoad: () => roleAuthGuard(ROLES.Admin),

	head: () => ({
		meta: [
			{
				title: 'Notification Recipients | BitLyft AIR®',
			},
		],
	}),

	component: RouteComponent,
	pendingComponent: RouteSkeleton,
	errorComponent: RouteErrorComponent,
})

function RouteComponent() {
	return (
		<>
			<div className="flex flex-col items-start justify-start gap-2">
				<p className="text-muted-foreground">Notification Recipients for:</p>
				<TenantSettingsSelect adminOnly />
			</div>

			<SettingsCard>
				<SettingsCardTitle>Notification Recipients</SettingsCardTitle>

				<ErrorBoundary>
					<Suspense fallback={<CustomNotificationsSkeleton />}>
						<CustomNotificationsSettings />
					</Suspense>
				</ErrorBoundary>
			</SettingsCard>
		</>
	)
}

function RouteSkeleton() {
	return (
		<>
			<div className="flex flex-col items-start justify-start gap-2">
				<p className="text-muted-foreground">Notification Recipients for:</p>
				<TenantSettingsSelect adminOnly />
			</div>

			<SettingsCard>
				<SettingsCardTitle>Notification Recipients</SettingsCardTitle>
				<CustomNotificationsSkeleton />
			</SettingsCard>
		</>
	)
}

function CustomNotificationsSkeleton() {
	return (
		<div className="flex w-full max-w-(--breakpoint-sm) flex-col gap-4">
			<div className="flex items-center justify-between">
				<Skeleton className="h-5 w-24" />
				<Skeleton className="h-8 w-32" />
			</div>
			<div className="flex w-full flex-col gap-2">
				<Skeleton className="h-16 w-full rounded-md" />
				<Skeleton className="h-16 w-full rounded-md" />
				<Skeleton className="h-16 w-full rounded-md" />
			</div>
		</div>
	)
}
